import type { SemanticColor } from '../../shared/components/semanticColor';
import type { EntityMarketFeedImportance } from '../../core/types/data-models';

/**
 * Pill / marker colour of one market feed signal's importance — shared by the
 * dashboard's Market Radar block and ManagedEntityTypeDetail's Market Feed tab.
 */
export const MARKET_FEED_IMPORTANCE_COLOR: Record<EntityMarketFeedImportance, SemanticColor> = {
  HIGH: 'error',
  MEDIUM: 'warning',
  LOW: 'secondary',
};
